<div class="mt-8 flex justify-content-center align-items-center">
  <div class="flex-column justify-content-center text-center">
    <i class="pi pi-ban p-primary" style="font-size: 10.5rem"></i>
    <h1 class="mt-4 p-primary">Δεν είστε εξουσιοδοτημένοι</h1>
    <h2 class="mt-4 p-gray">
      Φαίνεται ότι δεν έχετε άδεια να χρησιμοποιήσετε αυτήν την λειτουργία.
      <br />
      Παρακαλώ συνδεθείτε με διαφορετικό λογαριασμό.
    </h2>
  </div>
</div>
